import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';

import Form from 'core/forms/Form';
import Field from 'core/forms/Field';
import Button from 'common/components/Button';
import { InputValidator, MinLengthValidationRule, PasswordValidationRule } from 'core/validation';

import InputTextField from 'common/components/fields/InputTextField';

import RecaptchaField from 'common/components/fields/RecaptchaField';

import { localeStrings as strings } from 'applicationConfig';

import './restorePassword.scss';

@inject('settingsStore')
@observer
class RestorePasswordFormStep1 extends Component {
  onFormSubmit(props, values) {
    const settingsStore = this.props.settingsStore;

    values.isFormSubmitted = true;
    props.userStore
      .restorePassword(values.token, values.answer, values.newPassword)
      .catch((e) => {
        this.props.formStore.resetCaptcha();
        throw e;
      })
      .then(() => {
        props.history.push('/login');
        settingsStore.showSimpleAlert(strings.restorePassword.step1Success);
      });

    return false;
  }

  componentWillMount() {
    const values = this.props.formStore.values;
    this.props.userStore
      .getQuestion(values.token)
      .then((res) => {
        values.question = res.question;
      })
      .catch((e) => {
        this.props.history.push('/restore-password');
      });
  }

  render() {
    const submitButtonCaption = strings.restorePassword.submitButtonCaptions.step1;
    const question = this.props.formStore.values.question;

    return (
      <div>
        <Form
          className="restore-password-form"
          onSubmit={this.onFormSubmit.bind(this, this.props)}
          formStore={this.props.formStore}
        >
          <div className="step-field-group ">
            <div className="field-group required-field-group">
              <label className="field-group-label">{question}</label>
              <div className="field-group-value">
                <Field component={InputTextField} type="text" name="answer">
                  <InputValidator>
                    {[ new MinLengthValidationRule(strings.generic.errorMessages.invalidSecurityAnswer, 4) ]}
                  </InputValidator>
                </Field>
              </div>
            </div>
            <div className="field-group required-field-group">
              <label className="field-group-label">{strings.restorePassword.newPassword}</label>
              <div className="field-group-value">
                <Field component={InputTextField} type="password" name="newPassword">
                  <InputValidator>
                    {[ new PasswordValidationRule(strings.generic.errorMessages.passwordTooWeek, 8) ]}
                  </InputValidator>
                </Field>
              </div>
            </div>
          </div>
          <div>
            <div className="field-group captcha-field-group">
              <Field component={RecaptchaField} name="captchaVerified" />
            </div>
          </div>
          <div className="field-group-actions">
            <div className="actions">
              <Button
                className="btn btn-primary"
                type="submit"
                disabled={!this.props.formStore.isValid || this.props.formStore.isFormSubmitted}
              >
                <span className="button-caption">{submitButtonCaption}</span>
              </Button>
            </div>
          </div>
        </Form>
      </div>
    );
  }
}

export default RestorePasswordFormStep1;



// WEBPACK FOOTER //
// ./src/containers/RestorePassword/RestorePasswordFormStep1.jsx